import { render, staticRenderFns } from "./currentUser.vue?vue&type=template&id=78e9a0f0&scoped=true"
import script from "./currentUser.vue?vue&type=script&lang=js"
export * from "./currentUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e9a0f0",
  null
  
)

export default component.exports